/**
 * Atualiza o <select> escondido quando trocar um radio de variacao.
 */
function handleVariationRadioChange() {
  // Garante que o plugin do Woo esteja inicializado no form mesmo se
  // o auto-init tiver perdido o evento (ex.: form re-renderizado via AJAX).
  jQuery(function () {
    const $form = jQuery(".single form.variations_form");
    if ($form.length && jQuery.fn.wc_variation_form) {
      $form.each(function () {
        const $f = jQuery(this);
        if (!$f.data("wc_variation_form_initialized")) {
          $f.wc_variation_form();
          $f.data("wc_variation_form_initialized", true);
        }
      });
    }
  });

  // Sincroniza o radio -> select escondido. Ouve tanto "change" quanto "click"
  // no label porque o input fica sr-only e em alguns navegadores o "change"
  // pode não propagar antes do CSS :has() reagir.
  function syncRadioToSelect($radio) {
    const form = $radio.closest("form.variations_form");
    const val = $radio.val();
    const name = $radio.attr("name");
    const select = form.find(
      `.hidden-variations-select select[name="${name}"]`
    );

    if (!select.length) return;

    // Garante que o radio está marcado (defensivo)
    $radio.prop("checked", true);

    // Aplica o valor no select escondido
    const $option = select.find(`option[value="${val}"]`);
    if (!$option.length) {
      console.warn(
        "[variations] option não encontrada no select escondido:",
        name,
        val,
        select.find("option").map(function () { return jQuery(this).val(); }).get()
      );
      return;
    }

    select
      .val(val)
      .trigger("change")
      .trigger("woocommerce_variation_select_change");
    form.trigger("check_variations");
  }

  jQuery(document).on(
    "change",
    ".single .variation-radios input[type=radio]",
    function () {
      syncRadioToSelect(jQuery(this));
    }
  );

  // Fallback: clique direto no label/card também sincroniza
  jQuery(document).on(
    "click",
    ".single .variation-radio-card",
    function () {
      const $radio = jQuery(this).find("input[type=radio]");
      if ($radio.length) {
        $radio.prop("checked", true);
        syncRadioToSelect($radio);
      }
    }
  );

  // Sincroniza estado "disabled" das <option> escondidas com os cards de radio.
  // O Woo desabilita opções incompatíveis sempre que o usuário muda algum atributo;
  // ouvimos o evento "woocommerce_update_variation_values" disparado depois disso.
  function syncRadioDisabledState() {
    jQuery(".single form.variations_form").each(function () {
      const form = jQuery(this);
      form.find(".hidden-variations-select select").each(function () {
        const name = jQuery(this).attr("name");
        jQuery(this)
          .find("option")
          .each(function () {
            const value = jQuery(this).val();
            if (!value) return;
            const card = form
              .find(
                `.variation-radios input[type=radio][name="${name}"][value="${value}"]`
              )
              .closest(".variation-radio-card");
            if (!card.length) return;
            if (jQuery(this).is(":disabled")) {
              card.addClass("is-unavailable");
            } else {
              card.removeClass("is-unavailable");
            }
          });
      });
    });
  }

  jQuery(document).on(
    "woocommerce_update_variation_values reset_data",
    "form.variations_form",
    syncRadioDisabledState
  );
}

/**
 * Incrementa a quantidade na tela.
 */
function handleQtyIncrease() {
  jQuery(document).on(
    "click",
    ".single .woocommerce-variation-add-to-cart .qty-increase",
    function (e) {
      e.preventDefault();
      const container = jQuery(this).closest(
        ".woocommerce-variation-add-to-cart"
      );
      const qtyInput = container.find("input.qty");
      const current = parseInt(qtyInput.val(), 10) || 1;
      qtyInput.val(current + 1).trigger("change");
    }
  );
}

/**
 * Decrementa a quantidade na tela.
 */
function handleQtyDecrease() {
  jQuery(document).on(
    "click",
    ".single .woocommerce-variation-add-to-cart .qty-decrease",
    function (e) {
      e.preventDefault();
      const container = jQuery(this).closest(
        ".woocommerce-variation-add-to-cart"
      );
      const qtyInput = container.find("input.qty");
      const current = parseInt(qtyInput.val(), 10) || 1;
      if (current > 1) {
        qtyInput.val(current - 1).trigger("change");
      }
    }
  );
}

/**
 * Sincroniza os radios com o select escondido ao carregar a pagina.
 */
function syncRadiosWithSelect() {
  jQuery(".hidden-variations-select select").each(function () {
    const select = jQuery(this);
    const selected = select.val();
    if (selected) {
      const radio = jQuery(
        `.variation-radios input[type=radio][value="${selected}"]`
      );
      if (radio.length) {
        radio.prop("checked", true).trigger("change");
      }
    }
  });
}

/**
 * Calcula frete via AJAX na pagina de produto.
 */
function calculateProductShipping() {
  const getCurrentProductShippingPayload = () => {
    const calculator = jQuery(".product-shipping-calculator").first();
    const form = jQuery("form.cart").first();
    const quantity = parseInt(form.find("input.qty").first().val(), 10) || 1;
    const variationId =
      parseInt(form.find('input[name="variation_id"]').val(), 10) || 0;
    const productId =
      parseInt(form.find('input[name="product_id"]').val(), 10) ||
      parseInt(form.find('[name="add-to-cart"]').val(), 10) ||
      parseInt(calculator.data("product-id"), 10) ||
      0;

    return {
      product_id: productId,
      variation_id: variationId,
      quantity,
    };
  };

  jQuery("#product_cep").on("input", function () {
    let value = jQuery(this).val().replace(/\D/g, "");
    if (value.length > 5) {
      value = value.replace(/^(\d{5})(\d)/, "$1-$2");
    }
    jQuery(this).val(value);
  });

  jQuery("#product_calc_shipping").on("click", function (e) {
    e.preventDefault();
    const cep = jQuery("#product_cep").val().replace(/\D/g, "").trim();
    const methodsContainer = jQuery("#product_shipping_methods");
    const button = jQuery(this);
    const payload = getCurrentProductShippingPayload();

    if (!cep || cep.length !== 8) {
      return methodsContainer.html(
        '<p class="text-red-600 text-sm">Por favor, insira um CEP valido com 8 digitos.</p>'
      );
    }

    if (!payload.product_id) {
      return methodsContainer.html(
        '<p class="text-red-600 text-sm">Nao foi possivel identificar o produto para calcular a entrega.</p>'
      );
    }

    button.prop("disabled", true).addClass("opacity-50");
    methodsContainer.html(
      '<p class="text-gray-600 text-sm">Calculando frete...</p>'
    );

    jQuery
      .post(my_ajax_object.ajax_url, {
        action: "calc_shipping_product",
        cep,
        product_id: payload.product_id,
        variation_id: payload.variation_id,
        quantity: payload.quantity,
      })
      .done((resp) => {
        if (resp.success) {
          methodsContainer.html(resp.data.shipping_methods);
        } else {
          const message = resp?.data?.message || resp?.data || "";
          methodsContainer.html(
            `<p class="text-red-600 text-sm">${message}</p>`
          );
        }
      })
      .fail(() => {
        methodsContainer.html(
          '<p class="text-red-600 text-sm">Erro ao calcular frete. Tente novamente.</p>'
        );
      })
      .always(() => {
        button.prop("disabled", false).removeClass("opacity-50");
      });
  });
}

/**
 * Reordena via JS as secoes relacionadas, ingredientes e preparo.
 */
function reorderSections() {
  jQuery(document).ready(() => {
    const product = jQuery(".single .body-single-main");
    const related = jQuery(".single section.related.products");
    const ingredientes = jQuery(".single section.ingredientes");
    const preparacao = jQuery(".single section.preparacao");

    if (related.length && product.length) {
      related.detach().insertAfter(product);
    }
    if (ingredientes.length) {
      ingredientes.detach().insertAfter(product);
    }
    if (preparacao.length) {
      preparacao.detach().insertAfter(ingredientes);
    }
  });
}

/**
 * Intercepta o submit do form de produto variável e adiciona via AJAX,
 * abrindo o cart-drawer no mesmo padrão do produto simples.
 */
function handleVariableAddToCart() {
  jQuery(document).on(
    "submit",
    ".single form.variations_form",
    function (e) {
      const $form = jQuery(this);
      const variationId =
        parseInt($form.find('input[name="variation_id"]').val(), 10) || 0;
      const productId =
        parseInt($form.find('input[name="product_id"]').val(), 10) ||
        parseInt($form.data("product_id"), 10) ||
        0;

      if (!variationId || !productId) {
        // Sem variação válida: deixa o Woo tratar (vai mostrar o alert nativo)
        return;
      }

      e.preventDefault();

      const $button = $form.find(".single_add_to_cart_button");
      const quantity =
        parseInt($form.find("input.qty").val(), 10) || 1;

      // Coleta atributos selecionados (attribute_xxx)
      const variationAttrs = {};
      $form.find('.hidden-variations-select select').each(function () {
        const name = jQuery(this).attr("name");
        const val = jQuery(this).val();
        if (name) variationAttrs[name] = val || "";
      });

      $button.prop("disabled", true).addClass("opacity-50");

      jQuery
        .ajax({
          type: "POST",
          url: wc_add_to_cart_params.ajax_url,
          data: Object.assign(
            {
              action: "woocommerce_ajax_add_to_cart",
              product_id: productId,
              quantity: quantity,
              variation_id: variationId,
              variation: variationAttrs,
            },
            variationAttrs
          ),
        })
        .done(function (response) {
          if (response && response.error && response.product_url) {
            window.location = response.product_url;
            return;
          }

          jQuery(document.body).trigger("added_to_cart", [
            response.fragments,
            response.cart_hash,
            $button,
          ]);

          setTimeout(function () {
            jQuery(".added_to_cart.wc-forward").remove();
          }, 10);

          setTimeout(function () {
            if (typeof window.refreshCartDrawer === "function") {
              window.refreshCartDrawer();
            }
            if (typeof window.openCartDrawer === "function") {
              window.openCartDrawer();
            }
          }, 300);
        })
        .always(function () {
          $button.prop("disabled", false).removeClass("opacity-50");
        });
    }
  );
}

/**
 * Inicializa os accordions de "Ingredientes", "Como preparar", etc.
 */
function initAccordion() {
  jQuery(document).on(
    "click",
    ".product-accordion .accordion-toggle",
    function () {
      const toggle = jQuery(this);
      toggle.next(".accordion-content").slideToggle(200);
      toggle.toggleClass("open");
    }
  );
}

export {
  handleVariationRadioChange,
  handleQtyIncrease,
  handleQtyDecrease,
  syncRadiosWithSelect,
  calculateProductShipping,
  reorderSections,
  initAccordion,
  handleVariableAddToCart,
};
